import _toConsumableArray from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _createForOfIteratorHelper from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { useI18n } from "vue-i18n";
import { ModalComponents, ModalStatus } from "@/constants/modal";
import BookingModule from "@/store/modules/booking";
import { PCTypes, RetailOptionType } from "@/types/db/product-category";
import { dialogVisibleForStatus, hideDialog } from "@/utils/vue-helpers/modal";
import { computed, ref, defineComponent } from "vue";
import { PSBErrors } from "@/constants/errors/product-slot-booking";
import { priceCountInBooking } from "@/utils/helpers/product-slot-booking";
import ModalModule from "@/store/modules/modal";
import { createPSS } from "@/utils/helpers/product-slot-state";
import { Currencies } from "@/constants/currency";
import { formatAndConvertToLocale, formatDateTime, nowDB } from "@/utils/helpers/dates";
import { getLanguage } from "@/utils/helpers/lang";
import { updateDiscount } from "@/utils/vue-helpers/discount";
import { BookingStatus, PaymentStatus, PSSType } from "@/types/db/product-slot-state";
import { createImageproxyUrl } from "@/utils/helpers/pictures";
import Calculator from "./calculator/Calculator.vue";
import { PCSELECT_IMAGE_HEIGHT, PCSELECT_IMAGE_MEASUREMENT_UNIT, PCSELECT_IMAGE_WIDTH } from "@/constants/style";
import { converttoICardData, filterPrices, getSameStockPCs, sellOnSoldOut } from "@/utils/helpers/product-category";
import { getProductCategoryById } from "@/dexie/product-category";
import { getPriceAutomaticAddons, getPriceNonAutomaticAddons, getPssAvailability, getAutomaticAddonQuantityInBooking } from "@/utils/vue-helpers/product-slot-state";
import dayjs from "dayjs";
import NotificationService from "@/services/notification.service";
import { attachCustomFields } from "@/utils/vue-helpers/booking";
import { LogService } from "@/services/logging";
import { cloneDeep } from "lodash";
import PSSModule from "@/store/modules/pss";
import { createDiscountCodeAccounting, createPaymentCodeAccounting, hasAppliedGenericDiscountTracking, removeAllDiscountCodePendingAccountings, removeAllPaymentCodePendingAccountings, updateGenericDiscountAccountings } from "@/utils/vue-helpers/new-accountings";
import { AccountingState, PaymentMethods, PromocodeCampaignType } from "@/types/db/accounting";
import POSConfigModule from "@/store/modules/pos-config";
import { hasAddonsEnabled } from "@/utils/vue-helpers/addons";
import { recordOperationDuration } from "@/utils/vue-helpers/common";
import { PSSErrors } from "@/constants/errors/product-slot-state";
import { recreateIncertVoucherAccountings } from "@/api/external-vouchers/incert";
import { applyOffersToBooking } from "@/utils/helpers/offers";
import { syncBookingAvailabilities } from "@/utils/helpers/booking";

var __default__ = defineComponent({
  name: ModalComponents.PCSelect,
  components: {
    Calculator: Calculator
  },
  setup: function setup() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _useI18n, t, dialogVisible, pc, ts, prices, pricesCount, pricesBookingCount, isLoading, showSuccessMessage, currentLanguage, editingPrice, editedPrices, showNewPriceCalculator, pricePlaceHolder, priceDescriptionMaxLength, isRetail, sharedStocksWithOverbooking, isDisabled, availabilities, userInputSum, getPC, _getPC, productCategoryFullName, priceName, priceDescription, productPicture, pricesDiff, canBook, isPriceMaxQuantityReached, getModalTop, getDefaultRetailOptionSmeetzPicture, isPriceValueEditable, isPssCustomizedPriceValue, countPssAllConfirmed, countConfirmedPSS, maxInputValue, pssCustomizedPriceValue, getEditedPriceValue, pcselectPictureSize, sortedPrices, togglePriceDescription, truncatePriceDescription;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              truncatePriceDescription = function _truncatePriceDescrip(text, max) {
                return text.length > max ? text.slice(0, max) + " ..." : text;
              };

              togglePriceDescription = function _togglePriceDescripti(index, description, max) {
                var row = this.$refs.pricesRef[index];
                var currentDescription = row.querySelector(".price-description");
                var seeMoreLess = row.querySelector(".see-more");

                if (currentDescription.innerText.length < description.length) {
                  currentDescription.innerText = description;
                  seeMoreLess.innerText = t("button.see-less");
                } else {
                  currentDescription.innerText = truncatePriceDescription(description, max);
                  seeMoreLess.innerText = t("button.see-more");
                }
              };

              sortedPrices = function _sortedPrices(prices) {
                console.log("----- hi from sortedPrices");
                console.log("prices");
                console.log(prices); // for ticket products, sort by priceSort

                if (!isRetail.value) {
                  return prices.sort(function (a, b) {
                    var _a$sortPrice, _b$sortPrice;

                    return ((_a$sortPrice = a.sortPrice) !== null && _a$sortPrice !== void 0 ? _a$sortPrice : 25) - ((_b$sortPrice = b.sortPrice) !== null && _b$sortPrice !== void 0 ? _b$sortPrice : 25);
                  });
                } // for retail products, sort by retail.optionSort


                return prices.sort(function (a, b) {
                  var _a$retail$0$optionSor, _b$retail$0$optionSor;

                  return ((_a$retail$0$optionSor = a.retail[0].optionSort) !== null && _a$retail$0$optionSor !== void 0 ? _a$retail$0$optionSor : 25) - ((_b$retail$0$optionSor = b.retail[0].optionSort) !== null && _b$retail$0$optionSor !== void 0 ? _b$retail$0$optionSor : 25);
                });
              };

              getEditedPriceValue = function _getEditedPriceValue(priceId) {
                var editedPrice = this.editedPrices.find(function (p) {
                  return p.priceId === priceId;
                });

                if (!editedPrice) {
                  return null;
                }

                return editedPrice.newPriceValue;
              };

              pssCustomizedPriceValue = function _pssCustomizedPriceVa(priceId) {
                var _BookingModule$select5;

                if (!isPssCustomizedPriceValue(priceId)) return null;
                var pssList = (_BookingModule$select5 = BookingModule.selectedBooking) === null || _BookingModule$select5 === void 0 ? void 0 : _BookingModule$select5.pssList.filter(function (pss) {
                  return pss.priceId === priceId;
                });

                if (!pssList || !pssList.length) {
                  return null;
                }

                var pss = pssList[0];
                if (pss.paymentStatus === PaymentStatus.Started && pss._discountValue) return pss.priceValue + pss._discountValue;else {
                  return pss.priceValue;
                }
              };

              maxInputValue = function _maxInputValue(priceId) {
                return Math.max(availabilities.value + pricesCount.value[priceId], 0);
              };

              countConfirmedPSS = function _countConfirmedPSS(priceId) {
                var _BookingModule$select4;

                var confirmedPssList = (_BookingModule$select4 = BookingModule.selectedBooking) === null || _BookingModule$select4 === void 0 ? void 0 : _BookingModule$select4.pssList.filter(function (pss) {
                  var _ts$value4;

                  return pss.priceId === priceId && pss.bookingStatus === BookingStatus.Confirmed && (pss.pssType === PSSType[PSSType.Retail] || pss.timeSlotId === ((_ts$value4 = ts.value) === null || _ts$value4 === void 0 ? void 0 : _ts$value4.id));
                });

                if (confirmedPssList && confirmedPssList.length) {
                  return confirmedPssList.length;
                }

                return 0;
              };

              countPssAllConfirmed = function _countPssAllConfirmed(priceId, count) {
                var _BookingModule$select3;

                var confirmedPssList = (_BookingModule$select3 = BookingModule.selectedBooking) === null || _BookingModule$select3 === void 0 ? void 0 : _BookingModule$select3.pssList.filter(function (pss) {
                  var _ts$value3;

                  return pss.priceId === priceId && pss.bookingStatus === BookingStatus.Confirmed && (pss.pssType === PSSType[PSSType.Retail] || pss.timeSlotId === ((_ts$value3 = ts.value) === null || _ts$value3 === void 0 ? void 0 : _ts$value3.id));
                });

                if (!confirmedPssList) {
                  return false;
                }

                if (confirmedPssList.length === count) {
                  return true;
                }

                return false;
              };

              isPssCustomizedPriceValue = function _isPssCustomizedPrice(priceId) {
                var _BookingModule$select2, _pc$value25, _pc$value25$prices$fi;

                var pssList = (_BookingModule$select2 = BookingModule.selectedBooking) === null || _BookingModule$select2 === void 0 ? void 0 : _BookingModule$select2.pssList.filter(function (pss) {
                  return pss.priceId === priceId;
                });

                if (!pssList) {
                  return false;
                }

                var originalPriceValue = (_pc$value25 = pc.value) === null || _pc$value25 === void 0 ? void 0 : (_pc$value25$prices$fi = _pc$value25.prices.find(function (pr) {
                  return pr.id === priceId;
                })) === null || _pc$value25$prices$fi === void 0 ? void 0 : _pc$value25$prices$fi.value;
                var isCustomized = pssList === null || pssList === void 0 ? void 0 : pssList.some(function (pss) {
                  // lets ignore the addons
                  if (pss.mainTicketUUID) return false; // If payment has started then pss.discountValue has been already deducted from pss.value,
                  // lets consider this case too since user is able to come back here when the payment is processing

                  if (pss.paymentStatus === PaymentStatus.Started && pss._discountValue) return pss.priceValue + pss._discountValue !== originalPriceValue;else {
                    return pss.priceValue !== originalPriceValue;
                  }
                });
                return isCustomized;
              };

              isPriceValueEditable = function _isPriceValueEditable(price) {
                var _BookingModule$select;

                if (!price.isEditable) return false;
                var pssList = (_BookingModule$select = BookingModule.selectedBooking) === null || _BookingModule$select === void 0 ? void 0 : _BookingModule$select.pssList.filter(function (pss) {
                  return pss.priceId === price.id;
                });
                return pssList && pssList.length ? false : true;
              };

              getDefaultRetailOptionSmeetzPicture = function _getDefaultRetailOpti(pc) {
                var smeetzPicture = pc.prices[0].retail[0].smeetzPictures[0];
                return smeetzPicture;
              };

              isPriceMaxQuantityReached = function _isPriceMaxQuantityRe(priceId) {
                var _pc$value22, _pc$value23;

                // Will be used to make sure that we have enough availability for the price the user is trying to increase from
                // If retail product then price.quantity of the current price is the availability
                // If ticket product then we consider timeslot.availability
                var avail = 0;

                if (isRetail.value) {
                  var _pc$value21, _pc$value21$prices$fi;

                  avail = ((_pc$value21 = pc.value) === null || _pc$value21 === void 0 ? void 0 : (_pc$value21$prices$fi = _pc$value21.prices.find(function (p) {
                    return p.id === priceId;
                  })) === null || _pc$value21$prices$fi === void 0 ? void 0 : _pc$value21$prices$fi.quantity) || 0;
                } else {
                  var _ts$value2;

                  avail = ((_ts$value2 = ts.value) === null || _ts$value2 === void 0 ? void 0 : _ts$value2.availability) || 0;
                }

                var priceCount = pricesCount.value[priceId];

                if (priceCount >= avail && !sellOnSoldOut((_pc$value22 = pc.value) === null || _pc$value22 === void 0 ? void 0 : _pc$value22.prices, (_pc$value23 = pc.value) === null || _pc$value23 === void 0 ? void 0 : _pc$value23.type) && !sharedStocksWithOverbooking.value) {
                  return true;
                }

                return false;
              };

              priceDescription = function _priceDescription(price) {
                return isRetail.value ? "" : price.descriptionLocale ? price.descriptionLocale[currentLanguage.value] || price.description : price.description;
              };

              priceName = function _priceName(price) {
                // if it is a ticket product then we return the translated name of the price if there is translation, otherwise we return the price name
                // if it is a retail product then we return the translated name of the retail if there is translation, otherwise we return the price name
                // if it is a retail product but there are not retail options, there is only the default retail, then we consider the categoryName name and its translations
                if (!isRetail.value) {
                  return price.nameLocale ? price.nameLocale[currentLanguage.value] || price.name : price.name;
                }

                if (isRetail.value) {
                  if (price.retail[0].type !== RetailOptionType.Default_Retail_Option) {
                    return price.retail[0].nameLocale ? price.retail[0].nameLocale[currentLanguage.value] || price.retail[0].name : price.retail[0].name;
                  }

                  if (price.retail[0].type === RetailOptionType.Default_Retail_Option) {
                    var _pc$value18, _pc$value19;

                    return ((_pc$value18 = pc.value) === null || _pc$value18 === void 0 ? void 0 : _pc$value18.nameLocale[currentLanguage.value]) || ((_pc$value19 = pc.value) === null || _pc$value19 === void 0 ? void 0 : _pc$value19.name);
                  }
                }
              };

              _getPC = function _getPC3() {
                _getPC = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                  var _pc$value26;

                  var selectedPC, booking, pricesCountt, pricesBookingCountt, pcPricess, pricess, _iterator, _step, _ts$value5, _pc$value27, price, priceId, priceCount;

                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.prev = 0;
                          _context.next = 3;
                          return BookingModule.fetchSelectedPC();

                        case 3:
                          selectedPC = _context.sent;
                          _context.next = 10;
                          break;

                        case 6:
                          _context.prev = 6;
                          _context.t0 = _context["catch"](0);
                          NotificationService.showGeneralResponseError();
                          LogService.info("Error fetching selected PC", {
                            error: _context.t0
                          });

                        case 10:
                          if (selectedPC) {
                            _context.next = 12;
                            break;
                          }

                          return _context.abrupt("return");

                        case 12:
                          pc.value = filterPrices(selectedPC);

                          if (isRetail.value) {
                            _context.next = 20;
                            break;
                          }

                          _context.next = 16;
                          return BookingModule.fetchSelectedTimeslot();

                        case 16:
                          _context.t1 = _context.sent;

                          if (_context.t1) {
                            _context.next = 19;
                            break;
                          }

                          _context.t1 = null;

                        case 19:
                          ts.value = _context.t1;

                        case 20:
                          booking = BookingModule.selectedBooking;

                          if (booking) {
                            _context.next = 23;
                            break;
                          }

                          throw new Error(PSBErrors.NoBookingInModule);

                        case 23:
                          pricesCountt = pricesCount.value;
                          pricesBookingCountt = pricesBookingCount.value;
                          pcPricess = ((_pc$value26 = pc.value) === null || _pc$value26 === void 0 ? void 0 : _pc$value26.prices) || [];
                          pricess = prices.value; // build price related objects object (count, diff & count in booking)

                          _iterator = _createForOfIteratorHelper(pcPricess);

                          try {
                            for (_iterator.s(); !(_step = _iterator.n()).done;) {
                              price = _step.value;
                              priceId = price.id;
                              priceCount = priceCountInBooking(booking, {
                                priceId: priceId,
                                timeslotId: (_ts$value5 = ts.value) === null || _ts$value5 === void 0 ? void 0 : _ts$value5.id,
                                categoryId: (_pc$value27 = pc.value) === null || _pc$value27 === void 0 ? void 0 : _pc$value27.id
                              }); // Initially, count in booking and component is the same

                              pricesBookingCountt[priceId] = priceCount;
                              pricesCountt[priceId] = priceCount;
                              pricess[priceId] = price;
                            }
                          } catch (err) {
                            _iterator.e(err);
                          } finally {
                            _iterator.f();
                          }

                        case 29:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[0, 6]]);
                }));
                return _getPC.apply(this, arguments);
              };

              getPC = function _getPC2() {
                return _getPC.apply(this, arguments);
              };

              _useI18n = useI18n({}), t = _useI18n.t; // Modal is visible for PCSelect

              dialogVisible = dialogVisibleForStatus(ModalStatus.PCSelect);
              pc = ref(null);
              ts = ref(null);
              prices = ref({});
              pricesCount = ref({});
              pricesBookingCount = ref({});
              isLoading = ref(false);
              showSuccessMessage = ref(false);
              currentLanguage = ref(getLanguage());
              editingPrice = ref();
              editedPrices = ref([]);
              showNewPriceCalculator = ref(false);
              pricePlaceHolder = ref(0);
              priceDescriptionMaxLength = 80;
              isRetail = computed(function () {
                var _pc$value;

                return ((_pc$value = pc.value) === null || _pc$value === void 0 ? void 0 : _pc$value.type) === PCTypes[PCTypes.Retail];
              });
              sharedStocksWithOverbooking = computed(function () {
                var _pc$value2, _pc$value3;

                return ((_pc$value2 = pc.value) === null || _pc$value2 === void 0 ? void 0 : _pc$value2.stockIds) && ((_pc$value3 = pc.value) === null || _pc$value3 === void 0 ? void 0 : _pc$value3.stockIds.length) && pc.value.stockIds.includes(-1000);
              });
              isDisabled = computed(function () {
                var _pc$value4, _pc$value5;

                if (pc.value && (_pc$value4 = pc.value) !== null && _pc$value4 !== void 0 && _pc$value4.prices && (_pc$value5 = pc.value) !== null && _pc$value5 !== void 0 && _pc$value5.prices.length) {
                  for (var i = 0; i < pc.value.prices.length; i++) {
                    var _pc$value6, _pc$value7;

                    var priceId = pc.value.prices[i].id;

                    if (pricesCount.value[priceId] < countConfirmedPSS(priceId)) {
                      return true;
                    }

                    if (!sellOnSoldOut((_pc$value6 = pc.value) === null || _pc$value6 === void 0 ? void 0 : _pc$value6.prices, (_pc$value7 = pc.value) === null || _pc$value7 === void 0 ? void 0 : _pc$value7.type) && !sharedStocksWithOverbooking.value && pricesCount.value[priceId] > maxInputValue(priceId)) {
                      return true;
                    }
                  }

                  return false;
                } else {
                  return true;
                }
              });
              _context2.next = 36;
              return getPC();

            case 36:
              availabilities = computed(function () {
                // If retail product then sum all prices.quantity of the product category
                // If ticket product then return timeslot.availability
                var avail = 0;

                if (isRetail.value) {
                  var _pc$value8, _pc$value9;

                  if (((_pc$value8 = pc.value) === null || _pc$value8 === void 0 ? void 0 : _pc$value8.prices.length) === 1 && ((_pc$value9 = pc.value) === null || _pc$value9 === void 0 ? void 0 : _pc$value9.prices[0].retail[0].type) === RetailOptionType.Default_Retail_Option) {
                    var _pc$value10;

                    // It is retail product but with only one default retail option
                    avail = (_pc$value10 = pc.value) === null || _pc$value10 === void 0 ? void 0 : _pc$value10.prices[0].quantity;
                  } else {
                    var _pc$value11;

                    // this retail has options other than the default one
                    (_pc$value11 = pc.value) === null || _pc$value11 === void 0 ? void 0 : _pc$value11.prices.filter(function (p) {
                      return p.retail.every(function (r) {
                        return r.type !== RetailOptionType.Default_Retail_Option;
                      });
                    }).map(function (p) {
                      return p.quantity;
                    }).forEach(function (quantity) {
                      return avail = avail + quantity;
                    });
                  }
                } else {
                  var _ts$value;

                  avail = ((_ts$value = ts.value) === null || _ts$value === void 0 ? void 0 : _ts$value.availability) || 0;
                }

                return avail - userInputSum.value;
              });
              userInputSum = computed(function () {
                var count = 0;

                if (!pricesCount.value) {
                  return 0;
                }

                for (var _i = 0, _Object$keys = Object.keys(pricesCount.value); _i < _Object$keys.length; _i++) {
                  var priceId = _Object$keys[_i];
                  var numPriceId = Number(priceId);
                  count = count + pricesCount.value[numPriceId];
                }

                return count;
              });

              /**
               * If merch product then return pc.name
               * If ticket product then return pc.product.name + pc.name
               */
              productCategoryFullName = computed(function () {
                var _pc$value12, _pc$value13, _pc$value14, _pc$value15, _pc$value16, _pc$value17;

                return isRetail.value ? ((_pc$value12 = pc.value) === null || _pc$value12 === void 0 ? void 0 : _pc$value12.nameLocale[currentLanguage.value]) || ((_pc$value13 = pc.value) === null || _pc$value13 === void 0 ? void 0 : _pc$value13.name) : (((_pc$value14 = pc.value) === null || _pc$value14 === void 0 ? void 0 : _pc$value14.product.nameLocale[currentLanguage.value]) || ((_pc$value15 = pc.value) === null || _pc$value15 === void 0 ? void 0 : _pc$value15.product.name) || "") + " - " + (((_pc$value16 = pc.value) === null || _pc$value16 === void 0 ? void 0 : _pc$value16.nameLocale[currentLanguage.value]) || ((_pc$value17 = pc.value) === null || _pc$value17 === void 0 ? void 0 : _pc$value17.name));
              });
              /**
               * If merch product then return retailOption name
               * If ticket product then return priceName
               */

              productPicture = computed(function () {
                if (pc.value) {
                  if (!isRetail.value) {
                    var _pc$value20;

                    return (_pc$value20 = pc.value) === null || _pc$value20 === void 0 ? void 0 : _pc$value20.product.pictureUrl;
                  } else {
                    return createImageproxyUrl(getDefaultRetailOptionSmeetzPicture(pc.value), {
                      width: 150
                      /*Number(PCSELECT_IMAGE_WIDTH)*/
                      ,
                      height: 150
                      /*Number(PCSELECT_IMAGE_HEIGHT)*/

                    }) || require("@/assets/images/icons/shopping-icon.png");
                  }
                } else {
                  return require("@/assets/images/icons/shopping-icon.png");
                }
              });
              pricesDiff = computed(function () {
                var diffs = {};

                if (!pricesCount.value) {
                  return {};
                }

                for (var _i2 = 0, _Object$keys2 = Object.keys(pricesCount.value); _i2 < _Object$keys2.length; _i2++) {
                  var priceId = _Object$keys2[_i2];
                  var numPriceId = Number(priceId);
                  diffs[numPriceId] = pricesCount.value[numPriceId] - pricesBookingCount.value[numPriceId];
                }

                return diffs;
              }); // Checks whether user can book or not

              canBook = computed(function () {
                // if we have non zero diff on a price, we can book
                for (var _i3 = 0, _Object$keys3 = Object.keys(pricesDiff.value); _i3 < _Object$keys3.length; _i3++) {
                  var priceId = _Object$keys3[_i3];
                  var priceDiff = pricesDiff.value[Number(priceId)];

                  if (pricesDiff.value[Number(priceId)] !== 0) {
                    return true;
                  }
                }

                return false;
              });
              getModalTop = computed(function () {
                var _pc$value24;

                // Returns how close the modal is to the top of the window
                var defaultTop = 15;
                var toBeDeductedTop = !pc.value ? 0 : ((_pc$value24 = pc.value) === null || _pc$value24 === void 0 ? void 0 : _pc$value24.prices.length) * 3.5;
                var top = defaultTop > toBeDeductedTop ? defaultTop - toBeDeductedTop + "vh" : "0vh";
                return top;
              });
              /**
               * Takes the Product Category and returns RetailOption.SmeetzPictures of the first price for picture display use
               * If the retail has the only one option we show the default option picture
               * Otherwise we show the first retaoil option picture
               * Why we don't always show the default retail option picture?
               * Because when the retail has many options we are not considering the default one inside pc.prices (it will not exist)
               */

              pcselectPictureSize = computed(function () {
                return {
                  width: PCSELECT_IMAGE_WIDTH + PCSELECT_IMAGE_MEASUREMENT_UNIT,
                  height: PCSELECT_IMAGE_HEIGHT + PCSELECT_IMAGE_MEASUREMENT_UNIT
                };
              });
              return _context2.abrupt("return", {
                RetailOptionType: RetailOptionType,
                t: t,
                dialogVisible: dialogVisible,
                pc: pc,
                ts: ts,
                pricesCount: pricesCount,
                pricesDiff: pricesDiff,
                canBook: canBook,
                isLoading: isLoading,
                prices: prices,
                currentLanguage: currentLanguage,
                isRetail: isRetail,
                availabilities: availabilities,
                productCategoryFullName: productCategoryFullName,
                productPicture: productPicture,
                isPriceMaxQuantityReached: isPriceMaxQuantityReached,
                priceName: priceName,
                priceDescription: priceDescription,
                formatAndConvertToLocale: formatAndConvertToLocale,
                getModalTop: getModalTop,
                editingPrice: editingPrice,
                editedPrices: editedPrices,
                showNewPriceCalculator: showNewPriceCalculator,
                isPriceValueEditable: isPriceValueEditable,
                pricePlaceHolder: pricePlaceHolder,
                getEditedPriceValue: getEditedPriceValue,
                isPssCustomizedPriceValue: isPssCustomizedPriceValue,
                countPssAllConfirmed: countPssAllConfirmed,
                pssCustomizedPriceValue: pssCustomizedPriceValue,
                pcselectPictureSize: pcselectPictureSize,
                formatDateTime: formatDateTime,
                sortedPrices: sortedPrices,
                countConfirmedPSS: countConfirmedPSS,
                isDisabled: isDisabled,
                maxInputValue: maxInputValue,
                sellOnSoldOut: sellOnSoldOut,
                sharedStocksWithOverbooking: sharedStocksWithOverbooking,
                togglePriceDescription: togglePriceDescription,
                truncatePriceDescription: truncatePriceDescription,
                priceDescriptionMaxLength: priceDescriptionMaxLength,
                hideDialog: hideDialog,
                showSuccessMessage: showSuccessMessage
              });

            case 45:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    increase: function increase(priceId) {
      if (this.isPriceMaxQuantityReached(priceId)) {
        // At this point we wannot increase, so lets just leave
        // TODO: Do something to inform user that this is the max quantity available of the price he is trying increase from
        return;
      }

      var priceCount = this.pricesCount[priceId];
      this.pricesCount[priceId] = priceCount + 1;
    },
    decrease: function decrease(priceId) {
      var priceCount = this.pricesCount[priceId];

      if (priceCount === 0) {
        return;
      }

      this.pricesCount[priceId] = priceCount - 1;
    },
    addToBasket: function addToBasket() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var operationStartTime, pricesDiff, booking, currentPSSCount, pc, ts, bookingUUID, prices, productCategoryId, pricesList, goToAddonsStep, pricesToAddToBasket, i, priceId, price, addons, productCardData, _iterator2, _step2, _priceId, priceDiff, priceValue, pssAddons, unavailableAddon, msg, canBook, _iterator3, _step3, addon, availability, _msg, tokenEndDate, _iterator4, _step4, _addon, basePSSConfig, pssList, restOfAddons, _loop, _i8, _ret, restOfPSS, pcIds, sameStockPCs, sameStockPCsIds, _iterator5, _step5, pss, psc, automaticAddonPC, updatedBooking, key, _bookingCopy3, pssListBalances, _iterator6, _step6, _loop2, _ret2, _updatedBooking, groupCurrencies, groupCurrency, groupCurrencyLabel, hasGenericDiscount, hasPendingGenericDiscountAccounting, genericDiscountAccIndex, hasPromocodeDiscount, hasPaymentCode, bookingCopy, bookingCopy1, sortedAppliedDiscountCodes, _i4, sortedAppliedPaymentCodes, _i5, _bookingCopy, _bookingCopy2, _sortedAppliedDiscountCodes, _i6, _sortedAppliedPaymentCodes, _i7, operationEndTime, operationDuration;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                operationStartTime = performance.now();
                pricesDiff = _this.pricesDiff;
                booking = BookingModule.selectedBooking;

                if (booking) {
                  _context3.next = 5;
                  break;
                }

                throw new Error(PSBErrors.NoBookingInModule);

              case 5:
                currentPSSCount = booking.pssList.length; // pc and ts were already checked so cast them directly

                pc = _this.pc;
                ts = _this.ts;
                bookingUUID = booking.uuid;
                prices = _this.prices;
                productCategoryId = pc.id;
                _this.isLoading = true;
                pricesList = Object.keys(pricesDiff).map(function (priceId) {
                  return Number(priceId);
                }); // check if prices require addons

                goToAddonsStep = false;
                pricesToAddToBasket = [];
                i = 0;

              case 16:
                if (!(i < pricesList.length)) {
                  _context3.next = 28;
                  break;
                }

                priceId = pricesList[i];
                price = prices[priceId];

                if (!(pricesDiff[priceId] > 0)) {
                  _context3.next = 25;
                  break;
                }

                pricesToAddToBasket.push({
                  price: price,
                  pssQuantity: pricesDiff[priceId]
                });
                _context3.next = 23;
                return getPriceNonAutomaticAddons(price);

              case 23:
                addons = _context3.sent;

                if (addons.length) {
                  goToAddonsStep = true;
                }

              case 25:
                i++;
                _context3.next = 16;
                break;

              case 28:
                if (!(goToAddonsStep && hasAddonsEnabled.value)) {
                  _context3.next = 36;
                  break;
                }

                // we convert the selected pc into a ICardData object so we can pass it as a prop to the addons modal
                productCardData = converttoICardData([pc])[0];
                ModalModule.setModalProps({
                  props: {
                    selectedProduct: productCardData,
                    productCategory: pc,
                    isRetail: _this.isRetail,
                    pricesToAddToBasket: pricesToAddToBasket
                  }
                });
                ModalModule.setStatus(ModalStatus.Hidden);
                _context3.next = 34;
                return _this.$nextTick();

              case 34:
                ModalModule.setStatus(ModalStatus.Addons);
                return _context3.abrupt("return");

              case 36:
                // add and remove from booking all prices that have a non zero diff
                _iterator2 = _createForOfIteratorHelper(pricesList);
                _context3.prev = 37;

                _iterator2.s();

              case 39:
                if ((_step2 = _iterator2.n()).done) {
                  _context3.next = 169;
                  break;
                }

                _priceId = _step2.value;
                priceDiff = pricesDiff[_priceId]; // skip price if it has no diff

                if (!(priceDiff === 0)) {
                  _context3.next = 44;
                  break;
                }

                return _context3.abrupt("continue", 167);

              case 44:
                if (!(priceDiff > 0)) {
                  _context3.next = 161;
                  break;
                }

                // Create pss
                priceValue = _this.getEditedPriceValue(_priceId) ? _this.getEditedPriceValue(_priceId) : prices[_priceId].value; // let get the addons related to this product price

                pssAddons = [];
                _context3.prev = 47;
                _context3.next = 50;
                return getPriceAutomaticAddons(prices[_priceId], booking, ts ? ts.startDateTime : undefined, ts ? String(ts === null || ts === void 0 ? void 0 : ts.id) : undefined);

              case 50:
                pssAddons = _context3.sent;
                _context3.next = 61;
                break;

              case 53:
                _context3.prev = 53;
                _context3.t0 = _context3["catch"](47);

                if (!((_context3.t0 === null || _context3.t0 === void 0 ? void 0 : _context3.t0.message) === PSSErrors.UnavailableMandatoryAddon)) {
                  _context3.next = 61;
                  break;
                }

                // a custom error is thrown in case of unavailable mandatory addons
                _this.isLoading = false;
                unavailableAddon = _context3.t0.addon;
                msg = _this.t("error.unavailable-addon").replace("XXX", unavailableAddon);
                NotificationService.showCustomError(msg);
                return _context3.abrupt("return");

              case 61:
                // check the availability of the addons
                canBook = true;
                _iterator3 = _createForOfIteratorHelper(pssAddons);

                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    addon = _step3.value;
                    availability = getPssAvailability(addon);

                    if (availability < priceDiff && !sellOnSoldOut(addon.productCategory.prices, addon.productCategory.type) && !_this.sharedStocksWithOverbooking) {
                      canBook = false;
                      _msg = _this.t("availability.autumatic-addon").replace("X1", addon.productCategory.name).replace("X2", String(availability));
                      NotificationService.showCustomError(_msg);
                    }
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }

                if (canBook) {
                  _context3.next = 67;
                  break;
                }

                _this.isLoading = false;
                return _context3.abrupt("return");

              case 67:
                // if this pss have addons let's get the last endDateTime to be in the qrcode token
                tokenEndDate = (ts === null || ts === void 0 ? void 0 : ts.endDateTime) || null;
                _iterator4 = _createForOfIteratorHelper(pssAddons);
                _context3.prev = 69;

                _iterator4.s();

              case 71:
                if ((_step4 = _iterator4.n()).done) {
                  _context3.next = 78;
                  break;
                }

                _addon = _step4.value;

                if (_addon.timeslot) {
                  _context3.next = 75;
                  break;
                }

                return _context3.abrupt("continue", 76);

              case 75:
                if (!tokenEndDate || tokenEndDate && dayjs(_addon.timeslot.endDateTime).isAfter(tokenEndDate)) {
                  tokenEndDate = _addon.timeslot.endDateTime;
                }

              case 76:
                _context3.next = 71;
                break;

              case 78:
                _context3.next = 83;
                break;

              case 80:
                _context3.prev = 80;
                _context3.t1 = _context3["catch"](69);

                _iterator4.e(_context3.t1);

              case 83:
                _context3.prev = 83;

                _iterator4.f();

                return _context3.finish(83);

              case 86:
                basePSSConfig = {
                  pssType: _this.isRetail ? PSSType[PSSType.Retail] : PSSType[PSSType.Ticket],
                  bookingUuid: bookingUUID,
                  priceId: _priceId,
                  categoryId: productCategoryId,
                  priceValue: priceValue,
                  timeslot: ts,
                  productCategory: pc,
                  sellerId: booking.sellerId,
                  sendTicket: 1,
                  token: null,
                  mainSlot: null,
                  packagePriceId: null,
                  tokenEndDate: tokenEndDate,
                  bookingReference: booking.reference
                };
                _context3.next = 89;
                return createPSS(_objectSpread(_objectSpread({}, basePSSConfig), {}, {
                  count: 1,
                  addons: pssAddons
                }));

              case 89:
                pssList = _context3.sent;

                if (pssList && pssList.length) {
                  _this.showSuccessMessage = true;
                }

                if (!(priceDiff > 1)) {
                  _context3.next = 106;
                  break;
                }

                // if the quantity to add is larger than 1 and max addon quantity constraint was applied,
                // then the rest of the addons are added only if their max quantity is still greater than than their quantity in the booking
                restOfAddons = [];

                _loop = function _loop(_i8) {
                  var addon = pssAddons[_i8];

                  if (addon.accountingValue) {
                    // chillon package addons are excluded from this logic and have to be added either way
                    restOfAddons.push(addon);
                    return "continue";
                  }

                  var addonQtyInBooking = getAutomaticAddonQuantityInBooking(addon.packagePriceId, booking); // max quantity of addon has to be greater than ((addon quantity in booking) + (addon quantity that will be created) + 1 (to account for the addon already added above))

                  if ((addon.maxQuantity || 0) > addonQtyInBooking + restOfAddons.filter(function (a) {
                    return a.packagePriceId === addon.packagePriceId;
                  }).length + 1) {
                    restOfAddons.push(addon);
                  }
                };

                _i8 = 0;

              case 95:
                if (!(_i8 < pssAddons.length)) {
                  _context3.next = 102;
                  break;
                }

                _ret = _loop(_i8);

                if (!(_ret === "continue")) {
                  _context3.next = 99;
                  break;
                }

                return _context3.abrupt("continue", 99);

              case 99:
                _i8++;
                _context3.next = 95;
                break;

              case 102:
                _context3.next = 104;
                return createPSS(_objectSpread(_objectSpread({}, basePSSConfig), {}, {
                  count: priceDiff - 1,
                  addons: restOfAddons
                }));

              case 104:
                restOfPSS = _context3.sent;
                pssList = [].concat(_toConsumableArray(pssList), _toConsumableArray(restOfPSS));

              case 106:
                // add them to current booking
                // We need to consider same stock pcIds related to pss in pssExtension
                // lets first get an array of pcIds without duplicate from the created pss
                pcIds = _toConsumableArray(new Set(pssList.map(function (p) {
                  return String(p.categoryId);
                })));
                _context3.next = 109;
                return getSameStockPCs(pcIds);

              case 109:
                sameStockPCs = _context3.sent;
                BookingModule.addPSS({
                  bookingUUID: bookingUUID,
                  pssList: pssList
                }); // For each pss created lets add its extension
                // We need to consider same stock pcIds related to pss in pssExtension
                // lets first get an array of pcIds without duplicate from the created pss

                sameStockPCsIds = [];

                if (sameStockPCs && sameStockPCs.length) {
                  sameStockPCsIds = sameStockPCs.map(function (pc) {
                    return pc.id;
                  });
                }

                _iterator5 = _createForOfIteratorHelper(pssList);
                _context3.prev = 114;

                _iterator5.s();

              case 116:
                if ((_step5 = _iterator5.n()).done) {
                  _context3.next = 127;
                  break;
                }

                pss = _step5.value;
                psc = pc;

                if (!pss.isAutomaticAddon) {
                  _context3.next = 124;
                  break;
                }

                _context3.next = 122;
                return getProductCategoryById(pss.categoryId);

              case 122:
                automaticAddonPC = _context3.sent;

                if (automaticAddonPC) {
                  psc = automaticAddonPC;
                }

              case 124:
                if (sameStockPCsIds && sameStockPCsIds.length) {
                  PSSModule.addPSSExtensions([{
                    psc: psc,
                    pss: pss,
                    sameStockPCs: sameStockPCsIds
                  }]);
                } else {
                  PSSModule.addPSSExtensions([{
                    psc: psc,
                    pss: pss
                  }]);
                }

              case 125:
                _context3.next = 116;
                break;

              case 127:
                _context3.next = 132;
                break;

              case 129:
                _context3.prev = 129;
                _context3.t2 = _context3["catch"](114);

                _iterator5.e(_context3.t2);

              case 132:
                _context3.prev = 132;

                _iterator5.f();

                return _context3.finish(132);

              case 135:
                // If this the first PC of this booking then update the booking currency
                if (currentPSSCount === 0) {
                  // So the booking has the default currency (CHF), lets update it
                  // (creating a new booking object to avoid updating the original object in place)
                  updatedBooking = Object.assign({}, BookingModule.selectedBooking
                  /*booking*/
                  ); // Cast the currency string into a property of object type Currencies (USD, EUR, CHF..), then use it as an index Currencies[key]

                  key = pc.product.currency;
                  updatedBooking.currency = Currencies[key];
                  BookingModule.updateBooking(updatedBooking);
                } // Add custom fields if necessary


                if (pc.product.customBookingFields && pc.product.customBookingFields.length || pc.product.customTicketFields && pc.product.customTicketFields.length) {
                  LogService.info("So PC has custom fields, attaching custom fields to the booking and/or pss for booking ".concat(bookingUUID));
                  attachCustomFields({
                    pc: pc,
                    pssList: pssList.map(function (pss) {
                      return {
                        priceId: pss.priceId,
                        pssUuid: String(pss.uuid),
                        priceName: pss.priceName,
                        categoryId: pss.categoryId,
                        categoryName: pss.categoryName
                      };
                    })
                  });
                } // THIS IS NO LONGER NEEDED SINCE WE ARE CREATING PAYMENT CODES SOMEWHERE ELSE
                // // Now if the new PSS created are included in a Payment Promocode (voucher/giftcard)
                // // then we need to add them to the Code Payment accounting and create their TICKET accounting
                // // and confirm their status
                // const pssOfThePaymentCode = BookingModule.promocodeDiscountValues
                //   .filter(
                //     (p) =>
                //       p.codeTransactionType === CodeTransactionType.Payment &&
                //       p.promocodeDiscountValue > 0
                //   )
                //   .map((p) => p.pssUuid);
                // if (pssOfThePaymentCode) {
                //   // So we have a payment code applied
                //   for (const pss of pssList) {
                //     if (pssOfThePaymentCode.includes(String(pss.uuid))) {
                //       // So this newly created pss is considered in the applied payment Code
                //       // lets check if we already have an accounting for the applied code
                //       // so that we create accountingEntry for the pss and attach it to this accounting
                //       // lets get applied code id
                //       const appliedPaymentCodeId =
                //         BookingModule.appliedPromocode?.promocode.promoCodeId;
                //       // lets get payment code accounting
                //       const paymentCodeAccounting =
                //         BookingModule.selectedBooking?.accountings.find(
                //           (ac) => ac.promoCodeId === appliedPaymentCodeId
                //         );
                //       if (paymentCodeAccounting) {
                //         // 1- lets create accountingEntry for the pss
                //         createPromocodePaymentAccountingEntries(
                //           paymentCodeAccounting,
                //           [pss]
                //         );
                //         // 2- lets add TICKET accounting for the current pss
                //         const bookingCopy = cloneDeep(BookingModule.selectedBooking);
                //         if (bookingCopy) {
                //           bookingCopy.accountings.push(
                //             createTicketAccounting(pss, bookingCopy.currency)
                //           );
                //           BookingModule.updateBooking(bookingCopy);
                //         }
                //       }
                //     }
                //   }
                // }
                // Now if the pss that had the code applied are now fully paid, we need to complete there status


                _bookingCopy3 = cloneDeep(BookingModule.selectedBooking);

                if (!_bookingCopy3) {
                  _context3.next = 159;
                  break;
                }

                // If a pss is cancelled we don't complete it
                // If a pss has some amount paid we complete its bookingStatus
                // If a pss is fully paid we complete its paymentStatus
                pssListBalances = BookingModule.pssListBalances;
                _iterator6 = _createForOfIteratorHelper(_bookingCopy3.pssList);
                _context3.prev = 141;

                _loop2 = function _loop2() {
                  var pss = _step6.value;

                  if (pss.bookingStatus === BookingStatus.Canceled || pss.bookingStatus === BookingStatus.Abandoned) {
                    // cancelled/abandoned pss are not to be confirmed
                    return "continue";
                  } // if pss has a payment we confirmed we confirm its booking status


                  var balance = pssListBalances.find(function (b) {
                    return b.pssUuid === pss.uuid;
                  });

                  if (!balance) {
                    return "continue";
                  } else {
                    if (balance.accEntries && balance.accEntries.length) {
                      // so this pss has payment confirmed
                      pss.bookingStatus = BookingStatus.Confirmed; // if pss is actually fully paid then we confirm its paymentStatus

                      if (balance.balance === 0) {
                        pss.paymentStatus = PaymentStatus.Completed;
                      }
                    }
                  }

                  pss.updatedAt = nowDB();
                };

                _iterator6.s();

              case 144:
                if ((_step6 = _iterator6.n()).done) {
                  _context3.next = 150;
                  break;
                }

                _ret2 = _loop2();

                if (!(_ret2 === "continue")) {
                  _context3.next = 148;
                  break;
                }

                return _context3.abrupt("continue", 148);

              case 148:
                _context3.next = 144;
                break;

              case 150:
                _context3.next = 155;
                break;

              case 152:
                _context3.prev = 152;
                _context3.t3 = _context3["catch"](141);

                _iterator6.e(_context3.t3);

              case 155:
                _context3.prev = 155;

                _iterator6.f();

                return _context3.finish(155);

              case 158:
                BookingModule.updateBooking(_bookingCopy3);

              case 159:
                _context3.next = 161;
                return updateDiscount(_priceId, pssList);

              case 161:
                if (!(priceDiff < 0)) {
                  _context3.next = 167;
                  break;
                }

                // remove PSS from booking
                BookingModule.removePSS({
                  bookingUUID: bookingUUID,
                  criteria: {
                    pssType: _this.isRetail ? PSSType[PSSType.Retail] : PSSType[PSSType.Ticket],
                    retailOptionId: _this.isRetail ? prices[_priceId].retail[0].id : undefined,
                    timeslot: ts,
                    productCategoryId: productCategoryId,
                    priceId: _priceId,
                    bookingUuid: bookingUUID,
                    count: priceDiff * -1
                  }
                }); // apply offers after pss list is updated

                applyOffersToBooking(cloneDeep(BookingModule.selectedBooking)); // DiscountTracking update

                _context3.next = 166;
                return updateDiscount(_priceId);

              case 166:
                // if currently there is no pss in the booking we reset the currency to the default one
                if (!BookingModule.hasTickets) {
                  // (creating a new booking object to avoid updating the original object in place)
                  _updatedBooking = Object.assign({}, booking);
                  groupCurrencies = POSConfigModule.groupCurrencies;
                  groupCurrency = groupCurrencies.find(function (c) {
                    return c.isDefault === 1;
                  }) || groupCurrencies[0];
                  groupCurrencyLabel = groupCurrency.label;
                  _updatedBooking.currency = groupCurrencyLabel;
                  BookingModule.updateBooking(_updatedBooking);
                }

              case 167:
                _context3.next = 39;
                break;

              case 169:
                _context3.next = 174;
                break;

              case 171:
                _context3.prev = 171;
                _context3.t4 = _context3["catch"](37);

                _iterator2.e(_context3.t4);

              case 174:
                _context3.prev = 174;

                _iterator2.f();

                return _context3.finish(174);

              case 177:
                // New Logic of creating genericDiscount/promocodeDiscounts/paymentCodes accounting
                // TODO Hamza: we always update created acountings of genericDiscount/promocodeDiscunt/paymentCode here
                hasGenericDiscount = hasAppliedGenericDiscountTracking.value;
                hasPendingGenericDiscountAccounting = false;
                genericDiscountAccIndex = BookingModule.selectedBooking.accountings.findIndex(function (acc) {
                  return acc.state === AccountingState.Pending && !acc.refund && acc.paymentMethod === PaymentMethods.METHODS_POS_DISCOUNT;
                });

                if (genericDiscountAccIndex > -1) {
                  hasPendingGenericDiscountAccounting = true;
                }

                hasPromocodeDiscount = true;
                hasPaymentCode = true;

                if (hasGenericDiscount || hasPendingGenericDiscountAccounting) {
                  bookingCopy = cloneDeep(BookingModule.selectedBooking); /////////////////
                  // TODO Hamza: If we have applied codes for this booking, then we remove their accountings
                  //     - Remove pending payment code accountings of all applied payment codes

                  removeAllPaymentCodePendingAccountings(bookingCopy); //     - Remove pending discount code accountings of all applied discount codes

                  removeAllDiscountCodePendingAccountings(bookingCopy); // Now lets update the booking in the state before appyling the discount, and before applying any code
                  // BookingModule.updateBooking(bookingCopy);
                  /////////////////

                  updateGenericDiscountAccountings(bookingCopy);
                  BookingModule.updateBooking(bookingCopy); // Reusing bookingCopy for recreating codes accountings will not push restToPay to react

                  bookingCopy1 = cloneDeep(BookingModule.selectedBooking); /////////////////
                  // TODO Hamza: Recreate accountings for applied discount codes and then payment codes
                  //     - Create discount code accountings of all applied discount codes
                  // lets get all applied discount codes and sort them by applyDateTime

                  sortedAppliedDiscountCodes = BookingModule.appliedPromocodes.filter(function (p) {
                    return p.promocode.promoCodeType !== PromocodeCampaignType.TYPE_VOUCHER && p.promocode.promoCodeType !== PromocodeCampaignType.TYPE_VOUCHER_SOLD && p.promocode.promoCodeType !== PromocodeCampaignType.TYPE_GIFT_CARD && p.promocode.promoCodeType !== PromocodeCampaignType.TYPE_GIFT_CARD_SOLD;
                  });
                  /*.sort((p) => p.createdAt)*/

                  for (_i4 = 0; _i4 < sortedAppliedDiscountCodes.length; _i4++) {
                    createDiscountCodeAccounting(bookingCopy1, sortedAppliedDiscountCodes[_i4]);
                  } // BookingModule.updateBooking(bookingCopy);
                  //     - Create payment code accountings of all applied payment codes
                  // lets get all applied payment codes and sort them by applyDateTime


                  sortedAppliedPaymentCodes = BookingModule.appliedPromocodes.filter(function (p) {
                    return p.promocode.promoCodeType === PromocodeCampaignType.TYPE_VOUCHER || p.promocode.promoCodeType === PromocodeCampaignType.TYPE_VOUCHER_SOLD || p.promocode.promoCodeType === PromocodeCampaignType.TYPE_GIFT_CARD || p.promocode.promoCodeType === PromocodeCampaignType.TYPE_GIFT_CARD_SOLD;
                  });
                  /*.sort((p) => p.createdAt)*/

                  for (_i5 = 0; _i5 < sortedAppliedPaymentCodes.length; _i5++) {
                    createPaymentCodeAccounting(bookingCopy1, sortedAppliedPaymentCodes[_i5]);
                  }

                  BookingModule.updateBooking(bookingCopy1); /////////////////
                } else {
                  // There is no generic discount applied
                  // We remove any discount/payment codes accounting that were generated by an applied code
                  // and then we recreate them
                  _bookingCopy = cloneDeep(BookingModule.selectedBooking); //     - Remove pending payment code accountings of all applied payment codes

                  removeAllPaymentCodePendingAccountings(_bookingCopy); //     - Remove pending discount code accountings of all applied discount codes

                  removeAllDiscountCodePendingAccountings(_bookingCopy);
                  BookingModule.updateBooking(_bookingCopy); // Reusing bookingCopy for recreating codes accountings will not push restToPay to react

                  _bookingCopy2 = cloneDeep(BookingModule.selectedBooking); /////////////////
                  // TODO Hamza: Recreate accountings for applied discount codes and then payment codes
                  //     - Create discount code accountings of all applied discount codes
                  // lets get all applied discount codes and sort them by applyDateTime

                  _sortedAppliedDiscountCodes = BookingModule.appliedPromocodes.filter(function (p) {
                    return p.promocode.promoCodeType !== PromocodeCampaignType.TYPE_VOUCHER && p.promocode.promoCodeType !== PromocodeCampaignType.TYPE_VOUCHER_SOLD && p.promocode.promoCodeType !== PromocodeCampaignType.TYPE_GIFT_CARD && p.promocode.promoCodeType !== PromocodeCampaignType.TYPE_GIFT_CARD_SOLD;
                  });
                  /*.sort((p) => p.createdAt)*/

                  for (_i6 = 0; _i6 < _sortedAppliedDiscountCodes.length; _i6++) {
                    createDiscountCodeAccounting(_bookingCopy2, _sortedAppliedDiscountCodes[_i6]);
                  } // BookingModule.updateBooking(bookingCopy);
                  //     - Create payment code accountings of all applied payment codes
                  // lets get all applied payment codes and sort them by applyDateTime


                  _sortedAppliedPaymentCodes = BookingModule.appliedPromocodes.filter(function (p) {
                    return p.promocode.promoCodeType === PromocodeCampaignType.TYPE_VOUCHER || p.promocode.promoCodeType === PromocodeCampaignType.TYPE_VOUCHER_SOLD || p.promocode.promoCodeType === PromocodeCampaignType.TYPE_GIFT_CARD || p.promocode.promoCodeType === PromocodeCampaignType.TYPE_GIFT_CARD_SOLD;
                  });
                  /*.sort((p) => p.createdAt)*/

                  for (_i7 = 0; _i7 < _sortedAppliedPaymentCodes.length; _i7++) {
                    createPaymentCodeAccounting(_bookingCopy2, _sortedAppliedPaymentCodes[_i7]);
                  }

                  BookingModule.updateBooking(_bookingCopy2);
                } // Now lets recreate Incert voucher accountings


                recreateIncertVoucherAccountings(); // Check booking availabilities

                syncBookingAvailabilities(booking); // meausre addToBasket performance

                operationEndTime = performance.now();
                operationDuration = operationEndTime - operationStartTime;
                recordOperationDuration("add_to_basket", operationDuration);
                _this.isLoading = false;
                _this.dialogVisible = false;
                hideDialog();
                _context3.next = 194;
                return _this.$nextTick();

              case 194:
                if (_this.showSuccessMessage) {
                  NotificationService.showCustomSuccess(_this.t("products.tickets-added"));
                }

              case 195:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[37, 171, 174, 177], [47, 53], [69, 80, 83, 86], [114, 129, 132, 135], [141, 152, 155, 158]]);
      }))();
    },
    editPrice: function editPrice(priceId) {
      this.editingPrice = priceId; // show calculator for the user to enter the new price (show the old price as a placeholder in the calculator)

      this.showNewPriceCalculator = true;
      this.pricePlaceHolder = this.prices[priceId] ? this.prices[priceId].value / 100 : 0; // ModalModule.setStatus(ModalStatus.Calculator);
    },
    saveNewPrice: function saveNewPrice(priceId, newPrice) {
      // do nothing if the new price has the same value as the original value
      if (this.prices[priceId] && this.prices[priceId].value === newPrice) {
        return;
      }

      this.editedPrices.push({
        priceId: priceId,
        oldPriceValue: this.prices[priceId].value,
        newPriceValue: newPrice
      });
      this.editingPrice = null;
    },
    handleCalculatorClick: function handleCalculatorClick(newPrice) {
      if (!this.editingPrice) {
        return;
      } // If the new price has 3 decimal digits or more, we round it to be using only 2 decimal digits


      var formattedValue = Math.round(newPrice * 100);
      this.saveNewPrice(this.editingPrice, formattedValue);
      this.hideCalculator();
    },
    hideCalculator: function hideCalculator() {
      this.showNewPriceCalculator = false;
    }
  }
});

import { useCssVars as _useCssVars } from 'vue';

var __injectCSSVars__ = function __injectCSSVars__() {
  _useCssVars(function (_ctx) {
    return {
      "2d1aeb3c": _ctx.pcselectPictureSize.height,
      "12cdbd11": _ctx.pcselectPictureSize.width
    };
  });
};

var __setup__ = __default__.setup;
__default__.setup = __setup__ ? function (props, ctx) {
  __injectCSSVars__();

  return __setup__(props, ctx);
} : __injectCSSVars__;
export default __default__;